module.exports = __webpack_public_path__ + "img/alarm-device.8a6da7f1.svg";